export const isNearThreadBottom = (scrollTop: number, clientHeight: number, scrollHeight: number): boolean =>
  scrollHeight - scrollTop - clientHeight <= 96;

export const chatDraftKey = (sessionId: string): string => `chessla.nikola-chat-draft:${sessionId}`;

const utcDay = (value: string | Date): number => {
  const date = typeof value === "string" ? new Date(value) : value;
  return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
};

export const chatDayLabel = (createdAt: string, now = new Date()): string => {
  const daysAgo = Math.round((utcDay(now) - utcDay(createdAt)) / 86_400_000);
  if (daysAgo === 0) return "TODAY";
  if (daysAgo === 1) return "YESTERDAY";
  return new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" })
    .format(new Date(createdAt))
    .toUpperCase();
};

export interface ChatRequestIdentity {
  scope: string;
  requestId: string;
}

export const isCurrentChatRequest = (
  result: ChatRequestIdentity,
  current: ChatRequestIdentity | null,
  currentScope: string,
): boolean =>
  result.scope === currentScope && result.scope === current?.scope && result.requestId === current.requestId;

export const draftAfterAcceptedSend = (draft: string, acceptedMessage: string): string =>
  draft === acceptedMessage ? "" : draft;

interface ReviewContextReference {
  reference: { gameId: string; factId: string };
}
interface SelectionContext {
  gameId?: string;
  format?: "bullet" | "blitz" | "rapid" | "daily";
  moveNumber?: number;
  movePerspective?: "player" | "opponent";
  ply?: number;
}
export const buildChatRequestScope = (
  review: ReviewContextReference | null,
  reviewDismissed: boolean,
  selection: SelectionContext | null,
): { reviewMoment?: ReviewContextReference["reference"]; context?: SelectionContext } => {
  if (review && !reviewDismissed) return { reviewMoment: review.reference };
  return selection
    ? {
        context: {
          gameId: selection.gameId,
          format: selection.format,
          moveNumber: selection.moveNumber,
          movePerspective: selection.movePerspective,
          ply: selection.ply,
        },
      }
    : {};
};
